import { render } from "./FailedWebshopOrders.vue?vue&type=template&id=4b3704bf"
import script from "./FailedWebshopOrders.vue?vue&type=script&lang=js"
export * from "./FailedWebshopOrders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__